import { useIntl } from 'react-intl';
import { Header, HeaderProps } from '@rossum/components/header/Header';
import { SettingsBreadcrumbs } from '../../containers/Settings/SettingsBreadcrumbs';

type ConfigurationChangelogHeaderProps = Pick<
  HeaderProps,
  'scrollableDivRef'
> & {
  title: string;
};

export const ConfigurationChangelogHeader = ({
  title,
  ...props
}: ConfigurationChangelogHeaderProps) => {
  const intl = useIntl();

  return (
    <Header
      {...props}
      breadcrumbs={
        <SettingsBreadcrumbs
          breadcrumbs={[
            {
              label: intl.formatMessage({
                id: 'features.configurationChangelog.header.title',
              }),
            },
          ]}
        />
      }
      title={title}
      description={null}
    />
  );
};
